import React, { useState } from "react";
import Home from "../../../assets/images/leftsquremenu/dashboard.png";
import Order from "../../../assets/images/leftsquremenu/order.png";
import Reservation from "../../../assets/images/leftsquremenu/reservation.png";
import Tips from "../../../assets/images/leftsquremenu/tips.png";
import AdminTool from "../../../assets/images/leftsquremenu/admin-tools.png";
import { Avatar } from "@mui/material";
import { useNavigate } from "react-router-dom";

const menuInfo = [
  { icon: Home, title: "Dashboard", to: "/" },
  { icon: Order, title: "Order", to: "/all-tables" },
  { icon: Reservation, title: "Reservation", to: "/all-tables" },
  { icon: Tips, title: "Tips Adjustment", to: "/all-tables" },
  { icon: AdminTool, title: "Admin Tools", to: "/all-tables" },
];

const SideBarLeft = () => {
  const navigate = useNavigate();
  const [selectedIdx, setSelectedIdx] = useState(0);

  const handleMenu = (idx, to) => {
    setSelectedIdx(idx);
    navigate(to);
  };

  return (
    <div>
      {menuInfo.map((item, index) => (
        <MenuBox
          handleMenu={handleMenu}
          info={item}
          key={index}
          idx={index}
          selectedIdx={selectedIdx}
        />
      ))}
    </div>
  );
};

const MenuBox = ({ handleMenu, info, idx, selectedIdx }) => (
  <div
    style={{
      width: 112,
      height: 145,
      background: "#333C4B",
      marginTop: 2,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      borderLeft: `3px solid ${selectedIdx == idx ? "#ED1B24" : "#333C4B"}`,
    }}
    onClick={() => handleMenu(idx, info.to)}
  >
    <Avatar
      sx={{
        width: "70px",
        height: "70px",
      }}
      variant="square"
      src={info.icon}
    />

    <div
      style={{
        marginTop: 7,
        fontSize: 16,
        color: "#FFFFFF",
        padding: "0 5px",
        fontWeight: "500",
        fontFamily: `Roboto, sans-serif`,
      }}
    >
      {info.title}
    </div>
  </div>
);

export default SideBarLeft;
